import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { AuthGuard } from '@guards/auth.guard';

// Helper function to simplify route guards
const authGuard = () => [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivateFn(route, state)];

export const routes: Routes = [
  // 🔥 TABS PARA OPERADORES - Mantiene las páginas sin destruirlas
  {
    path: 'tabs',
    loadComponent: () => import('./pages/operator-tabs/operator-tabs.page').then(m => m.OperatorTabsPage),
    canActivate: authGuard(),
    children: [
      {
        path: 'sip',
        loadComponent: () => import('./pages/sip/sip.page').then(m => m.SipPage),
      },
      {
        path: 'services',
        loadComponent: () => import('./pages/services/services.page').then(m => m.ServicesPage),
      },
      {
        path: 'scheduled',
        loadComponent: () => import('./pages/scheduled/scheduled.page').then(m => m.ScheduledPage),
      },
      {
        path: 'taxi',
        loadComponent: () => import('./pages/taxi/taxi.page').then(m => m.TaxiPage),
      },
      {
        path: 'directions',
        loadComponent: () => import('./pages/directions/directions.page').then(m => m.DirectionsPage),
      },
      {
        path: '',
        redirectTo: 'sip',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage),
    canActivate: authGuard()
  },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then(m => m.HomePage),
    canActivate: authGuard()
  },
  {
    path: 'services',
    loadComponent: () => import('./pages/services/services.page').then(m => m.ServicesPage),
    canActivate: authGuard()
  },
  {
    path: 'services/new-service',
    loadComponent: () => import('./pages/services/pages/new-service/new-service.page').then(m => m.NewServicePage),
    canActivate: authGuard()
  },
  {
    path: 'services/edit-service/:id',
    loadComponent: () => import('./pages/services/pages/new-service/new-service.page').then(m => m.NewServicePage),
    canActivate: authGuard()
  },
  {
    path: 'services/service-detail/:id',
    loadComponent: () => import('./pages/services/pages/service-detail/service-detail.page').then(m => m.ServiceDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'scheduled',
    loadComponent: () => import('./pages/scheduled/scheduled.page').then(m => m.ScheduledPage),
    canActivate: authGuard()
  },
  {
    path: 'scheduled/new-service',
    loadComponent: () => import('./pages/services/pages/new-service/new-service.page').then(m => m.NewServicePage),
    canActivate: authGuard(),
    data: { scheduled: true }
  },
  {
    path: 'scheduled/edit-service/:id',
    loadComponent: () => import('./pages/services/pages/new-service/new-service.page').then(m => m.NewServicePage),
    canActivate: authGuard(),
    data: { scheduled: true }
  },
  {
    path: 'scheduled/service-detail/:id',
    loadComponent: () => import('./pages/services/pages/service-detail/service-detail.page').then(m => m.ServiceDetailPage),
    canActivate: authGuard(),
    data: { scheduled: true }
  },
  {
    path: 'taxi',
    loadComponent: () => import('./pages/taxi/taxi.page').then(m => m.TaxiPage),
    canActivate: authGuard()
  },
  {
    path: 'taxi/taxi-detail/:id',
    loadComponent: () => import('./pages/taxi/pages/taxi-detail/taxi-detail.page').then(m => m.TaxiDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'taxi/actions/:id',
    loadComponent: () => import('./pages/taxi/pages/actions/actions.page').then(m => m.ActionsPage),
    canActivate: authGuard()
  },
  {
    path: 'taxi/new-taxi',
    loadComponent: () => import('./pages/taxi/pages/taxi-detail/taxi-detail.page').then(m => m.TaxiDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'clients',
    loadComponent: () => import('./pages/clients/clients.page').then(m => m.ClientsPage),
    canActivate: authGuard(),
    data: { hotels: false }
  },
  {
    path: 'hotels',
    loadComponent: () => import('./pages/clients/clients.page').then(m => m.ClientsPage),
    canActivate: authGuard(),
    data: { hotels: true }
  },
  {
    path: 'clients/client-detail/:id',
    loadComponent: () => import('./pages/clients/pages/client-detail/client-detail.page').then(m => m.ClientDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'clients/edit-client/:id',
    loadComponent: () => import('./pages/clients/pages/client-detail/client-detail.page').then(m => m.ClientDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'hotels/edit-client/:id',
    loadComponent: () => import('./pages/clients/pages/client-detail/client-detail.page').then(m => m.ClientDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'messages',
    loadComponent: () => import('./pages/messages/messages.page').then(m => m.MessagesPage),
    canActivate: authGuard()
  },
  {
    path: 'messages/message-detail/:id',
    loadComponent: () => import('./pages/messages/pages/message-detail/message-detail.page').then(m => m.MessageDetailPage),
    canActivate: authGuard()
  }, {
    path: 'messages/new-message',
    loadComponent: () => import('./pages/messages/pages/message-detail/message-detail.page').then(m => m.MessageDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'zones',
    loadComponent: () => import('./pages/zones/zones.page').then(m => m.ZonesPage),
    canActivate: authGuard()
  },
  {
    path: 'zones/add-zone',
    loadComponent: () => import('./pages/zones/pages/add-zone-parada/add-zone-parada.page').then(m => m.AddZoneParadaPage),
    data: {
      type: 'zone'
    },
    canActivate: authGuard()
  },
  {
    path: 'zones/add-parada',
    loadComponent: () => import('./pages/zones/pages/add-zone-parada/add-zone-parada.page').then(m => m.AddZoneParadaPage),
    data: {
      type: 'parada'
    },
    canActivate: authGuard()
  }, {
    path: 'zones/edit-zone/:zoneId',
    loadComponent: () => import('./pages/zones/pages/add-zone-parada/add-zone-parada.page').then(m => m.AddZoneParadaPage),
    data: {
      type: 'zone'
    },
    canActivate: authGuard()
  }, {
    path: 'zones/edit-parada/:paradaId',
    loadComponent: () => import('./pages/zones/pages/add-zone-parada/add-zone-parada.page').then(m => m.AddZoneParadaPage),
    data: {
      type: 'parada'
    },
    canActivate: authGuard()
  },
  {
    path: 'global-zones',
    loadComponent: () => import('./pages/global-zones/global-zones.page').then(m => m.GlobalZonesPage),
    canActivate: authGuard()
  },
  {
    path: 'global-zones/add',
    loadComponent: () => import('./pages/global-zones/pages/global-zone-detail/global-zone-detail.page').then(m => m.GlobalZoneDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'global-zones/bulk-import',
    loadComponent: () => import('./pages/global-zones/pages/bulk-import-zones/bulk-import-zones.page').then(m => m.BulkImportZonesPage),
    canActivate: authGuard()
  },
  {
    path: 'global-zones/edit/:id',
    loadComponent: () => import('./pages/global-zones/pages/global-zone-detail/global-zone-detail.page').then(m => m.GlobalZoneDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'metrics',
    loadComponent: () => import('./pages/metrics/metrics.page').then(m => m.MetricsPage),
    canActivate: authGuard()
  },
  {
    path: 'history',
    loadComponent: () => import('./pages/history/history.page').then(m => m.HistoryPage),
    canActivate: authGuard()
  },
  {
    path: 'archive',
    loadComponent: () => import('./pages/archive/archive.page').then(m => m.ArchivePage),
    canActivate: authGuard()
  },
  {
    path: 'drivers',
    loadComponent: () => import('./pages/drivers/drivers.page').then(m => m.DriversPage),
    canActivate: authGuard()
  },
  {
    path: 'drivers/edit-driver/:id',
    loadComponent: () => import('./pages/drivers/pages/driver-detail/driver-detail.page').then(m => m.DriverDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'drivers/new-driver',
    loadComponent: () => import('./pages/drivers/pages/driver-detail/driver-detail.page').then(m => m.DriverDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'managers',
    loadComponent: () => import('./pages/managers/managers.page').then(m => m.ManagersPage),
    canActivate: authGuard()
  },
  {
    path: 'managers/new-manager',
    loadComponent: () => import('./pages/managers/pages/manager-detail/manager-detail.page').then(m => m.ManagerDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'managers/edit-manager/:id',
    loadComponent: () => import('./pages/managers/pages/manager-detail/manager-detail.page').then(m => m.ManagerDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'provinces',
    loadComponent: () => import('./pages/provinces/provinces.page').then(m => m.ProvincesPage),
    canActivate: authGuard()
  },
  {
    path: 'provinces/new-province',
    loadComponent: () => import('./pages/provinces/pages/province-detail/province-detail.page').then(m => m.ProvinceDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'provinces/edit-province/:id',
    loadComponent: () => import('./pages/provinces/pages/province-detail/province-detail.page').then(m => m.ProvinceDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/auth/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/auth/reset-password/reset-password.page').then(m => m.ResetPasswordPage)
  },
  {
    path: 'stripe-setup-success',
    loadComponent: () => import('./pages/stripe-setup-success/stripe-setup-success.page').then(m => m.StripeSetupSuccessPage)
  },
  {
    path: 'stripe-setup-cancel',
    loadComponent: () => import('./pages/stripe-setup-cancel/stripe-setup-cancel.page').then(m => m.StripeSetupCancelPage)
  },
  {
    path: 'create-driver/:register_token',
    loadComponent: () => import('./pages/auth/register/register.page').then(m => m.RegisterPage),
    data: {
      registerType: 'driver'
    }
  },
  {
    path: 'create-manager/:register_token',
    loadComponent: () => import('./pages/auth/register/register.page').then(m => m.RegisterPage),
    data: {
      registerType: 'manager'
    }
  },
  {
    path: 'action',
    loadComponent: () => import('./pages/auth/action/action.page').then(m => m.ActionPage)
  },
  {
    path: 'archive/new-document',
    loadComponent: () => import('./pages/archive/pages/document-detail/document-detail.page').then(m => m.DocumentDetailPage)
  },
  {
    path: 'archive/edit-document/:id',
    loadComponent: () => import('./pages/archive/pages/document-detail/document-detail.page').then(m => m.DocumentDetailPage)
  },
  {
    path: 'incidents',
    loadComponent: () => import('./pages/incidents/incidents.page').then(m => m.IncidentsPage),
    canActivate: authGuard()
  },
  {
    path: 'incidents/new-incident',
    loadComponent: () => import('./pages/incidents/pages/incident-detail/incident-detail.page').then(m => m.IncidentDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'incidents/incident-detail/:id',
    loadComponent: () => import('./pages/incidents/pages/incident-detail/incident-detail.page').then(m => m.IncidentDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'sessions',
    loadComponent: () => import('./pages/sessions/sessions.page').then(m => m.SessionsPage),
    canActivate: authGuard()
  },
  {
    path: 'sessions/session-detail/:id',
    loadComponent: () => import('./pages/sessions/pages/session-detail/session-detail.page').then(m => m.SessionDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'configuration',
    loadComponent: () => import('./pages/configuration/configuration.page').then(m => m.ConfigurationPage),
    canActivate: authGuard()
  },
  {
    path: 'price-simulator',
    loadComponent: () => import('./pages/price-simulator/price-simulator.page').then(m => m.PriceSimulatorPage),
    canActivate: authGuard()
  },
  {
    path: 'operators',
    loadComponent: () => import('./pages/operators/operators.page').then(m => m.OperatorsPage),
    canActivate: authGuard()
  },
  {
    path: 'operators/operator-detail/:id',
    loadComponent: () => import('./pages/operators/pages/operator-detail/operator-detail.page').then(m => m.OperatorDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'operators/edit-operator/:id',
    loadComponent: () => import('./pages/operators/pages/operator-detail/operator-detail.page').then(m => m.OperatorDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'delivery-system',
    loadComponent: () => import('./pages/delivery-system/delivery-system.page').then(m => m.DeliverySystemPage),
    canActivate: authGuard()
  },
  {
    path: 'delivery-system/new-delivery',
    loadComponent: () => import('./pages/delivery-system/pages/delivery-system-details/delivery-system-details.page').then(m => m.DeliverySystemDetailsPage),
    canActivate: authGuard()
  },
  {
    path: 'delivery-system/edit-delivery/:id',
    loadComponent: () => import('./pages/delivery-system/pages/delivery-system-details/delivery-system-details.page').then(m => m.DeliverySystemDetailsPage),
    canActivate: authGuard()
  },
  {
    path: 'control',
    loadComponent: () => import('./pages/control/control.page').then(m => m.ControlPage),
    canActivate: authGuard()
  },
  {
    path: 'contracts',
    loadComponent: () => import('./pages/contracts/contracts.page').then(m => m.ContractsPage),
    canActivate: authGuard()
  },
  {
    path: 'contracts/new-contract',
    loadComponent: () => import('./pages/contracts/pages/contract-detail/contract-detail.page').then(m => m.ContractDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'contracts/edit-contract/:id',
    loadComponent: () => import('./pages/contracts/pages/contract-detail/contract-detail.page').then(m => m.ContractDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'contracts/storage-test',
    loadComponent: () => import('./pages/contracts/pages/storage-test/storage-test.page').then(m => m.StorageTestPage),
    canActivate: authGuard()
  },
  {
    path: 'invoices',
    loadComponent: () => import('./pages/invoices/invoices.page').then(m => m.InvoicesPage),
    canActivate: authGuard()
  },
  {
    path: 'payments',
    loadComponent: () => import('./pages/payments/payments.page').then(m => m.PaymentsPage),
    canActivate: authGuard()
  },
  {
    path: 'payments/new',
    loadComponent: () => import('./pages/payments/pages/payment-detail/payment-detail.page').then(m => m.PaymentDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'payments/edit/:id',
    loadComponent: () => import('./pages/payments/pages/payment-detail/payment-detail.page').then(m => m.PaymentDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'stats',
    loadComponent: () => import('./pages/stats/stats.page').then(m => m.StatsPage),
    canActivate: authGuard()
  },
  {
    path: 'stats/new',
    loadComponent: () => import('./pages/stats/statsNew.page').then(m => m.StatsNewPage),
    canActivate: authGuard()
  },
  {
    path: 'sip',
    loadComponent: () => import('./pages/sip/sip.page').then(m => m.SipPage),
    canActivate: authGuard()
  },
  {
    path: 'realtime',
    loadComponent: () => import('./pages/realtime/realtime.page').then(m => m.RealtimePage),
    canActivate: authGuard()
  },
  {
    path: 'recover',
    loadComponent: () => import('./pages/recover/recover.page').then(m => m.RecoverPage),
    canActivate: authGuard()
  },
  {
    path: 'directions',
    loadComponent: () => import('./pages/directions/directions.page').then(m => m.DirectionsPage),
    canActivate: authGuard()
  },
  {
    path: 'directions/:id',
    loadComponent: () => import('./pages/directions-detail/directions-detail.page').then(m => m.DirectionsDetailPage),
    canActivate: authGuard()
  },
  {
    path: 'testing',
    loadComponent: () => import('./pages/testing/testing.page').then(m => m.TestingPage),
    canActivate: authGuard()
  }
];
